import { Controller } from 'react-hook-form';
import DateComponent from '../../inputs/date/date';
import { FormProps } from '../../../shared/interfaces/form';
import { useState, useEffect } from 'react';

interface FormDateProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
  handleDateChanged?: () => void;
}

const FormDate = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues,
  handleDateChanged
}: FormDateProps) => {
  const [ isDisabledDate, setIsDisabledDate ] = useState(false);
  
  const handleDateChange = (newValue: any, onChange: any) => {
    onChange(newValue);
    
    // Chama o callback sempre que finalDate for alterada
    if (item.name === 'finalDate') {
      setTimeout(() => {
        handleDateChanged?.();
      }, 100); // Pequeno delay para garantir que o valor foi setado
    }
  };

  useEffect(() => {
      const page = window.location.hash.split('/')[1];
  
      if(page && page.toLocaleLowerCase().includes('list')) {
        setIsDisabledDate(true);
      }
  
    }, []);
  
  return (
    <Controller
      key={`date-${index}-${baseId}-${item.name}`}
      name={item.name}
      control={control}
      defaultValue={item.value || null}
      rules={item.rules}
      render={({ field }) => (
        <DateComponent
          label={item.placeholder}
          value={field.value}
          width={item.width}
          height={item.height}
          onChange={(newValue: any) => handleDateChange(newValue, field.onChange)}
          disabled={isDisabled || isDisabledDate}
          dateToday={item.dateToday}
        />
      )}
    />
  );
};

export default FormDate;